import Button from '@components/Button';
import IconVip from '@components/icons/IconVip';
import { useSelect } from 'downshift';

export function MarkerAddButton<
  T extends readonly { name: string; isVip: boolean }[],
>({
  items,
  disabled,
  onSelect,
}: {
  items: T;
  disabled: boolean;
  onSelect: (val: T[number]) => void;
}) {
  const { isOpen, getToggleButtonProps, getMenuProps, getItemProps } =
    useSelect({
      items: [...items],
      selectedItem: null,
      onSelectedItemChange: (changes) => {
        if (changes.selectedItem) {
          onSelect(changes.selectedItem);
        }
      },
    });
  return (
    <div className="relative">
      <Button
        size="lg"
        className="w-full"
        disabled={disabled}
        {...getToggleButtonProps()}
      >
        添加标记点
      </Button>
      <div
        className="absolute z-30 mt-5 w-full select-none overflow-hidden rounded bg-white text-black focus:outline-none"
        {...getMenuProps()}
      >
        {isOpen &&
          items.map((item, index) => (
            <div
              className="flex h-30 cursor-pointer items-center justify-center px-10 hover:bg-white-light"
              key={item.name}
              {...getItemProps({ item, index })}
            >
              {item.name}
              {item.isVip && <IconVip className="ml-5" />}
            </div>
          ))}
      </div>
    </div>
  );
}
